
import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import CommonHeaderJa from '@/components/common/CommonHeaderJa.vue';
import CommonHeaderEn from '@/components/common/CommonHeaderEn.vue';
import CommonFooter from '@/components/common/CommonFooter.vue';
@Component({
  components: {
    CommonHeaderJa,
    CommonHeaderEn,
    CommonFooter,
  },
})
export default class NoneLayout extends Vue {
  get loaded(): boolean {
    return store.getters.loaded;
  }
  get lang(): string {
    return store.getters['auth/lang'];
  }
}
